import { render, staticRenderFns } from "./SdsSection2LabelForm.vue?vue&type=template&id=a57ea192"
import script from "./SdsSection2LabelForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsSection2LabelForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports